export default __webpack_public_path__ + "media/images/fuze-letters-6c6d9370ad532a54acaece0d163df874.svg";